import Product, { ProductRenderProps } from '../../product';
import NotFound from './not-found';
import { selectImage } from '../../../util/misc';
import { Feature, TypedFiles } from '../../../types/catalog';
import { FileCard, FileCardBasic } from './elements/file-card';
import FeatureTable from './elements/feature-table';
import LogisticFeatureTable from './elements/logistic-feature-table';
import { Fragment } from 'react';
import AnalogList from './elements/analog-list';

const ProductRender = ({ show, product }: ProductRenderProps) => {
    if (!product) {
        return <NotFound>Товар не найден</NotFound>;
    }
    const imgUrl = selectImage(product.imageVariants, 800, 400, product.imageUrl);
    const files = [];
    const typedFiles = [];
    for (const fileGroup of product.files) {
        if ((fileGroup.files[0] as TypedFiles).type) {
            typedFiles.push(fileGroup);
        } else {
            files.push(fileGroup);
        }
    }
    return (
        <div className="col-md-9">
            <h1 style={{ marginTop: 0 }}>{product.name}</h1>
            <table className="detail" style={{ width: '100%' }}>
                <tbody>
                    <tr className="tr-common">
                        <td style={{ width: '300px', verticalAlign: 'top' }} className="right-block">
                            <div className="iek-prodcat-catalog-detail-img-wrap">
                                <img
                                    className="iek-prodcat-catalog-detail-img"
                                    src={imgUrl}
                                    alt={product.name}
                                    title={product.name}
                                />
                            </div>

                            {show.files && files.length > 0 && (
                                <div className="iek-prodcat-catalog-detail-docs">
                                    <div className="iek-prodcat-catalog-detail-docs__title">
                                        Скачать документы
                                    </div>
                                    <div style={{ padding: '6px 6px 0 6px' }}>
                                        {files.map((fg) => (
                                            <FileCardBasic fileGroup={fg} />
                                        ))}
                                    </div>
                                </div>
                            )}
                            {show.files &&
                                typedFiles.length > 0 &&
                                typedFiles.map((fg) => <FileCard fileGroup={fg} />)}
                        </td>
                        <td style={{ width: '10px' }} className="block-line-vert">
                            &nbsp;
                        </td>
                        <td className="left-block" style={{ verticalAlign: 'top' }}>
                            <p style={{ textAlign: 'right', margin: 0 }}>
                                <a href="/kontakty/" target="_blank">
                                    Где купить?
                                </a>
                            </p>
                            <div style={{ marginBottom: '10px' }}>
                                <strong>Артикул:</strong> {product.article}
                            </div>
                            {show.description && (
                                <div
                                    style={{
                                        borderTop: '1px solid #29318c',
                                        borderBottom: '1px solid #29318c',
                                        padding: '15px 0',
                                        margin: '20px 0',
                                        whiteSpace: 'pre-line',
                                    }}
                                >
                                    {product.description}
                                </div>
                            )}
                            <div
                                style={{
                                    borderBottom: '1px solid #fbcb30',
                                    paddingBottom: '15px',
                                    margin: '15px 0',
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                }}
                            >
                                <a
                                    href="https://oni-system.com/produktsiya/configurators/oni-equipment/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Конфигуратор подбора оборудования ONI
                                </a>
                            </div>
                            {show.advantages && (
                                <p style={{ whiteSpace: 'pre-line' }}>{product.advantages}</p>
                            )}
                            {show.specs && (
                                <div style={{ border: '1px solid #ccc', borderRadius: '3px' }}>
                                    <FeatureTable
                                        features={product.etim?.features as Feature[]}
                                        title="Технические характеристики"
                                    />
                                </div>
                            )}
                            {show.usage && (
                                <div
                                    style={{
                                        border: '1px solid #ccc',
                                        borderRadius: '3px',
                                        marginTop: '10px',
                                    }}
                                >
                                    <FeatureTable
                                        features={product.leftPeriod as Feature[]}
                                        title="Эксплуатационные параметры"
                                    />
                                </div>
                            )}
                            {show.logistics && (
                                <div
                                    style={{
                                        border: '1px solid #ccc',
                                        borderRadius: '3px',
                                        marginTop: '10px',
                                    }}
                                >
                                    <LogisticFeatureTable features={product.logisticParams} />
                                </div>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
            {show.related && (
                <Fragment>
                    <h2>Совместно применяемые изделия:</h2>
                    <AnalogList analogs={product.related} />
                </Fragment>
            )}
            {show.analogs && (
                <Fragment>
                    <h2>Аналоги:</h2>
                    <AnalogList analogs={product.analogs} />
                </Fragment>
            )}
        </div>
    );
};

export function OniProduct() {
    return <Product render={ProductRender} />;
}

export default OniProduct;
